import { formatNumberToCurrency } from "@utils/formatNumber";
import { useEffect, useRef, useState } from "react";

const headerCellStyle = {
  padding: "8px 12px",
  borderBottom: "2px solid #ddd",
  textAlign: "right",
  whiteSpace: "nowrap",
  fontWeight: "bold",
};

const cellStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #eee",
  textAlign: "right",
  whiteSpace: "nowrap",
};

const valueColor = (value) => (value < 0 ? "#3CB371" : "#333");

const MIN_ITEM_WIDTH = 90;
const MAX_ITEM_WIDTH = 520;

const ExtraValuesMonthlyTable = ({ months, monthLabels, rows, net, totals, onSelectRow }) => {
  const [itemWidth, setItemWidth] = useState(240);
  const dragRef = useRef(null);

  const startDrag = (e) => {
    e.preventDefault();
    dragRef.current = { startX: e.clientX, startWidth: itemWidth };
  };

  useEffect(() => {
    const onMove = (e) => {
      if (!dragRef.current) return;
      const delta = e.clientX - dragRef.current.startX;
      const next = Math.min(MAX_ITEM_WIDTH, Math.max(MIN_ITEM_WIDTH, dragRef.current.startWidth + delta));
      setItemWidth(next);
    };
    const onUp = () => { dragRef.current = null; };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, []);

  const itemColStyle = {
    width: itemWidth,
    minWidth: itemWidth,
    maxWidth: itemWidth,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "fixed" }}>
        <thead>
          <tr>
            <th style={{ ...headerCellStyle, ...itemColStyle, textAlign: "left", position: "relative" }}>
              Item
              <span
                onMouseDown={startDrag}
                title="Arraste para redimensionar a coluna"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: 8,
                  height: "100%",
                  cursor: "col-resize",
                  borderRight: "2px solid #ccc",
                }}
              />
            </th>
            {monthLabels.map((label) => (
              <th key={label} style={headerCellStyle}>{label}</th>
            ))}
            <th style={headerCellStyle}>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.wbs_code_id}>
              <td
                style={{ ...cellStyle, ...itemColStyle, textAlign: "left", cursor: onSelectRow ? "pointer" : "default", color: onSelectRow ? "#245AE4" : undefined }}
                title={onSelectRow ? `${row.item_name} — ir para o item lançado` : row.item_name}
                onClick={() => onSelectRow?.(row.wbs_code_id)}
              >
                {row.item_name}
              </td>
              {months.map((month) => (
                <td key={month} style={{ ...cellStyle, color: valueColor(row.values[month] || 0) }}>
                  {row.values[month] ? formatNumberToCurrency(row.values[month]) : "-"}
                </td>
              ))}
              <td style={{ ...cellStyle, fontWeight: "bold", color: valueColor(row.total) }}>
                {formatNumberToCurrency(row.total)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td style={{ ...cellStyle, ...itemColStyle, textAlign: "left", fontWeight: "bold" }}>Total líquido</td>
            {months.map((month, index) => (
              <td key={month} style={{ ...cellStyle, fontWeight: "bold", color: valueColor(net[index]) }}>
                {formatNumberToCurrency(net[index])}
              </td>
            ))}
            <td style={{ ...cellStyle, fontWeight: "bold", color: valueColor(totals.net) }}>
              {formatNumberToCurrency(totals.net)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ExtraValuesMonthlyTable;
